export default {
  id: 'healthHistory/CHILD_DISEASES/v1',
  formSchema: {
    title: 'encounter:widget.healthHistory.childhoodDiseases',
    type: 'object',
    required: ['id001'],
    properties: {
      id001: {
        type: 'string',
        title: 'encounter:widget.healthHistory.childhoodDiseases',
        minLength: 1
      }
    }
  },
  uiSchema: {
    id001: { 'ui:widget': 'customCKEditorWidget' },
    'x-customClass': 'problem-description-widget'
  }
};
